import {
    ConfigurationContext,
    getSubscriptionOfferPublicationId,
    OfferGroup,
    queries,
} from '@news-mono/web-common'
import { useQuery } from '@tanstack/react-query'
import {
    GetOffersResult,
    OfferVariantType,
} from '@west-australian-newspapers/subscription-offer-types'
import { useContext } from 'react'

export const useSubscriptionOfferData = (
    offerGroup: OfferGroup,
    variant?: OfferVariantType,
    initialData?: GetOffersResult,
) => {
    const config = useContext(ConfigurationContext)
    const publicationId = getSubscriptionOfferPublicationId(
        config.publicHostname,
    )

    return useQuery({
        ...queries['subscription-offer-api'].definition({
            publicationId,
            offerGroup,
            variant,
            config: { subscriptionOfferApi: config.subscriptionOfferApi },
            initialData,
        }),
    })
}
